// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { jobTitleApi } from '../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export const OptionContent = styled.span.attrs(() => ({
  className: 'optionContent'
})).withConfig({
  displayName: "JobTitleSelect__OptionContent",
  componentId: "sc-w2l824-0"
})(["display:flex;justify-content:space-between;align-items:flex-start;flex-direction:column;"]);
export const OptionOrgUnit = styled.span.attrs(() => ({
  className: 'orgUnit'
})).withConfig({
  displayName: "JobTitleSelect__OptionOrgUnit",
  componentId: "sc-w2l824-1"
})(["color:#838d96;font-size:10px;line-height:1.7;"]);
export const OptionName = styled.span.attrs(() => ({
  className: 'name'
})).withConfig({
  displayName: "JobTitleSelect__OptionName",
  componentId: "sc-w2l824-2"
})(["white-space:nowrap;max-width:80%;text-overflow:ellipsis;overflow:hidden;"]);
export const Select = styled(AutocompleteSelect).withConfig({
  displayName: "JobTitleSelect__Select",
  componentId: "sc-w2l824-3"
})([".ant-select-selection-selected-value .orgUnit,.ant-select-selection__choice__content .orgUnit{display:none;}.ant-select-selection-selected-value .name,.ant-select-selection__choice__content .name{max-width:100%;}& .optionContent{height:initial;}"]);
export default ({
  filter = {},
  ...selectProps
}) => <Select fetch={async params => {
  return await jobTitleApi.fetchJobTitles({
    ...filter,
    ...params
  });
}} fetchSingle={jobTitleApi.fetchJobTitle} notFoundText="Должности не найдены" placeholder="Введите должность" renderOption={(jobTitle, Option) => <Option key={jobTitle.id} value={jobTitle.id} jobTitle={jobTitle}>
        <OptionContent>
          <OptionName>{jobTitle.name}</OptionName>
          <OptionOrgUnit>{jobTitle.orgUnitName}</OptionOrgUnit>
        </OptionContent>
      </Option>} {...selectProps} />;
